import AdminLayout from "../../../components/admin/layout/AdminLayout";
import useAuthStore from "../../../store/authStore";
import ManagerSidebar from "../../../components/managerLiveDashboard/sidebar/ManagerSidebar";
import ViewAllNotifcations from "../../../components/common/notification/ViewAllNotifcations";

function NotificationPage() {
  const { userType } = useAuthStore();

  return (
    <AdminLayout
      sidebarComponent={userType === 'admin' ? undefined : ManagerSidebar}
    >
      <ViewAllNotifcations />
    </AdminLayout>
  );
}

export default NotificationPage;

